module.exports = __webpack_public_path__ + "img/rule-3.eb16eaae.png";